import React, { useRef, useState, useEffect, useLayoutEffect, useMemo } from "react";
import { withRouter } from 'react-router-dom';

import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';

import ImageIcon from "../../../../../assets/images/ImageIcon.png";


import { useDataConfigListAll } from '../../../../../hooks/useDataConfigListAll';
import adwords from '../../../../../assets/images/adwords.png';
import meta from '../../../../../assets/images/meta.png';
import dv360 from '../../../../../assets/images/dv360.png';
import tiktok from '../../../../../assets/images/tiktok.png';
import ion from '../../../../../assets/images/ion.png';
import ViImage from '../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png';

import {
  reduxDataForPreviewCampaingDataAction,
} from '../../../../../actions/campaign';
import { useFetchPlatformData } from "../../../../../hooks/useFetchPlatformData";
import SelectNew from '../../../../../components/FormElements/SelectNew';
import { formFields } from "./constant"; // Import your formFields constant
import { handleFieldError, handleError } from '../../../../../utils/form-validation';
import Input from '../../../../../components/FormElements/Input';

import { LazyLoadImage } from "react-lazy-load-image-component";
import { defaultPlatformConfig } from "../../../../../constants/configuration";
import { getDateFromUtcToSpecificZone, getTenantTimeZone, isTenantDemoAdvertiser } from "../../../../../selectors";
import moment from "moment";
import { accountListAll } from "../../../../../constants/demo/campaignData";


const PreviewPublish = (props) => {

  const dispatch = useDispatch();

  let elementCampaignRef = useRef([]);
  let elementStrategyRef = useRef([]);

  const reduxConfigData = useDataConfigListAll()

  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const reduxPreviewData = useSelector((state) => get(state, "app.previewData", []));
  const campaignPublishData = useSelector((state) => get(state, "app.campaignPublishData", []));
  const thirdPartyList = useSelector((state) => get(state, 'app.thirdPartyList.responseObj', {}));
  const platformConfiguration = useSelector((state) => get(state, 'app.platformConfiguration', {}));
  const reduxDataForPlatform = useFetchPlatformData();

  const [seatData, setSeatData] = useState({
    // dv360: [], googleads: [], meta: [], ion: [], viads: []
  });
  const [campaingData, setCampaignData] = useState([]);
  const [campaigns, setCampaigns] = useState([[]]
  )

  const [strategyies, setStrategies] = useState([[]]);

  const [selectedCampaign, setSelectedCampaign] = useState(
    []
  );
  const [selectedStrategy, setSelectedStrategy] = useState([]);

  const [submited, setSubmited] = useState(false);
  const [dataValidate, setDataValidate] = useState([]);
  const [dataDraft, setDataDraft] = useState([]);

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({
    /* initial errors state */
  });

  const [selectedPlatforms, setSelectedPlatforms] = useState([]);

  const [selectedAccountIds, setSelectedAccountIds] = useState({});
  const [dataNameList, setDataNameList] = useState({});
  const [creativeConfig, setCreativeConfig] = useState([]);

  const targetTimeZone = getTenantTimeZone(tenantId);

  const isDemoAdvertiser = useMemo(() => {
    return isTenantDemoAdvertiser(tenantId);
  }, [tenantId]);

  useEffect(() => {
    // console.log(thirdPartyList, reduxDataForPlatform, "thirdPartyList, reduxDataForPlatform");
    if (reduxDataForPlatform && reduxDataForPlatform.length > 0) {
      setSeatDataFormatter(thirdPartyList, reduxDataForPlatform)
    }
  }, [thirdPartyList, reduxDataForPlatform])

  useEffect(() => {
    if (reduxConfigData && reduxConfigData.response.length > 0 && Object.keys(seatData).length > 0) {
      setCreativeConfig(prev => {
        const y = [...prev]
        Object.keys(seatData).map(item1 => {
          if (seatData && seatData[item1] && seatData[item1].length > 0 && seatData[item1][0]['platformId']) {
            const x = reduxConfigData.response.find(item => item.name == 'Media_Type' && item.platformId == seatData[item1][0]['platformId']);
            y.push(x);
          }
        })
        return y;
      })
    }
    // console.log(seatData);
  }, [seatData])

  useEffect(() => {
    if (campaignPublishData.length > 0 && Object.keys(seatData).length > 0) {
      elementCampaignRef.current = Array(Object.keys(seatData).length).fill().map((_, i) => elementCampaignRef.current[i] || React.createRef(null));
      elementStrategyRef.current = Array(Object.keys(seatData).length).fill().map((_, i) => elementStrategyRef.current[i] || React.createRef(null))

      const data = platformIndexFillerFormatter(campaignPublishData)
      setCampaignData(data);
    }
  }, [campaignPublishData, seatData])


  useEffect(() => {
    if (props.summary.length > 0) {
      const x = platformIndexFillerFormatter(props.summary);
      if (x.length > 0) {
        setCampaignData(prev => {
          const z = [...prev]
          const y = z.map((item) => {
            const correspondingItem = x.find(item2 => item.id === item2.id);
            if (correspondingItem && Object.keys(correspondingItem).length > 0) {
              return correspondingItem;
            } else {
              return item
            }
          });

          return y
        });
      }
    }
    if (props.campaignSuggestionNameList.length > 0) {
      setCampaignData(prev => {
        const x = [...prev]
        const mergedArray = x.map(item1 => {
          const matchingItem = props.campaignSuggestionNameList.find(item2 => item1.name.toLowerCase() == item2.name.toLowerCase());
          return { ...item1, ...matchingItem };
        });
        return mergedArray;
      })
    }
  }, [props.summary, props.campaignSuggestionNameList])

  useEffect(() => {
    if (campaingData.length > 0 && Object.keys(seatData).length > 0) {
      const x = Object.keys(seatData).map((x, i) => dataFormatter(i, campaingData))
      const y = getZerothElements(x)
      setSelectedCampaign(y);
      setSelectedStrategy(getZerothElements(Object.keys(seatData).map((x, i) => {
        if (elementCampaignRef && elementCampaignRef.current[i] && elementCampaignRef.current[i].current && elementCampaignRef.current[i].current.scrollLeft && elementStrategyRef && elementStrategyRef.current.length > 0 && elementStrategyRef.current[i].current && elementStrategyRef.current[i].current.scrollLeft) {
          elementStrategyRef.current[i].current.scrollLeft = 0
          elementCampaignRef.current[i].current.scrollLeft = 0
          setAllTrue();
        }
        if (y[i] && y[i].strategies && y[i].strategies.length > 0) {
          return y[i].strategies;
        } else {
          return [];
        }
      })))
      setStrategies(Object.keys(seatData).map((x, i) => {
        if (y[i] && y[i].strategies && y[i].strategies.length > 0) {
          return y[i].strategies
        } else { return [] }
      }
      ))
      setCampaigns(x);
      dispatch(reduxDataForPreviewCampaingDataAction({ data: x }));
    }

  }, [campaingData, seatData]);


  // Step 2: Function to extract 0th elements from each sub-array
  const getZerothElements = (data) => {
    return data.map(subArray => {
      if (subArray.length > 0) {
        return subArray[0]
      } else {
        return [];
      }
    }
    );
  };

  // const dataFormatter = (key, data) => {
  //   let x = [];
  //   x = data.filter(item => item.length > 0 && item[0]['platform'] == key)
  //   if (data && data.length > 0) {
  //     data[0]['selected'] = true;
  //     data[0]['strategies'][0]['selected'] = true;
  //   }

  //   return data;
  // }
  const dataFormatter = (key, data) => {
    let x = [];
    x = data.filter(item => item.platform == key);
    if (x.length > 0) {
      x[0]['selected'] = true;
      x[0]['strategies'][0]['selected'] = true;
    }
    return x;
  }

  const handleCheckboxChange = (platform) => {
    if (selectedPlatforms.includes(platform)) {
      setSelectedPlatforms((prevPlatforms) => prevPlatforms.filter((p) => p !== platform));
    } else {
      setSelectedPlatforms((prevPlatforms) => [...prevPlatforms, platform]);
    }
  };

  // Check if reduxPreviewData is truthy, otherwise set it to an empty object
  const initialPlatformData = reduxPreviewData ? reduxPreviewData.data : {};
  const [platformData, setPlatformData] = useState(initialPlatformData);
  useEffect(() => {
    // You can log the state here to check if it's being updated correctly
  }, [platformData]);

  useEffect(() => {
    // Update platformData when reduxPreviewData changes
    setPlatformData(reduxPreviewData ? reduxPreviewData.data : {});
  }, [reduxPreviewData]);


  const platformIdList = {
    ads: 4,
    meta: 3,
    dv360: 5,
    ion: 2,
    tiktok: 7,
    // ... add more platforms as needed
  };

  useEffect(() => {

    if (selectedAccountIds) {
      // const resultPayload = generateValidatePayload(selectedAccountIds, platformIdList, platformData);
      // const namelistpayload = generateNameListPayload(selectedAccountIds, platformIdList, platformData, reduxCampaignName);
      // const saveDraftPayload = generateSaveDraftPayload(selectedAccountIds, platformIdList, platformData);
      props.setPreviewValidateDetails({
        // data: resultPayload,
        data: dataValidate,
        totalPlatformNumbers: Object.keys(selectedAccountIds).length,
        totalPlatforms: campaigns.filter(item => item.length > 0).length,
        // dataForRedux: cloneDeep(resultPayload),
        nameData: dataNameList,
        // nameDataForRedux: cloneDeep(namelistpayload),
        saveDraft: dataDraft,
      });
    } else {
      props.setPreviewValidateDetails({ valid: false, data: {} });
    }
  }, [selectedAccountIds]);

  const platformIndexFillerFormatter = (response) => {
    const data = Object.keys(seatData).map((item, index) => {
      const found = response.filter(obj => seatData[item].length > 0 && obj.platformId == seatData[item][0]['platformId'])
      if (found.length > 0) {
        return found.map(obje => {
          return {
            ...obje,
            platform: index
          }
        })
      } else {
        return []
      }
    })
    return data.flat();
  }

  // const [boolArray, setBoolArray] = useState([]);
  useEffect(() => {
    setAllTrue();
    setSelectedPlatforms(Object.keys(seatData))
  }, [seatData])

  const [arrowDisable, setArrowDisable] = useState([]);
  // Function to set all elements of the array to true
  const setAllTrue = () => {
    const newArray = Object.keys(seatData).map(() => ({ campaign: { showBackward: false, showForward: true }, strategy: { showBackward: false, showForward: true } }))
    setArrowDisable(newArray);
  };

  const setStrategyTrue = () => {
    const newArray = Object.keys(seatData).map((_, index) => ({ campaign: { ...arrowDisable[index]['campaign'] }, strategy: { showBackward: false, showForward: true } }))
    setArrowDisable(newArray);
  }

  // Helper function to format options with accountName and accountId
  const formatOptions = (options, item) => {
    if (options) {
      return options.map((option) => {
        let isExpired = option.hasOwnProperty('isExpired') ? option.isExpired : false
        const formattedOption = {
          value: option.accountId ? option.accountId : null,
          platform: item,
          platformId: option.platformId,
          mccAccountId: option.masterAccountId ? option.masterAccountId : null,
          platformName: option.platformName,
          platformImage: getPlatformImage(option.platformName),
          label: option.accountName && option.accountId ? `${option.accountName ? `${option.accountName}` : 'No Name'} ${isExpired == 1 ? '(Expired)' : ''} (${option.accountId})` : null,
          disabled: isExpired
        }
        if (option.accountId) {
          return formattedOption
        } else {
          return item
        }
        // return Object.fromEntries(Object.entries(formattedOption).filter(([key, value]) => value !== null));
        // Remove null keys
      }
      )
    } else {
      return [{
        ...item,
        platformImage: getPlatformImage(item.value),
        platformName: item.value
      }];
    }

  };

  const [optionsKeys, setOptionsKey] = useState({});

  const setSeatDataFormatter = (accountData, platformData) => {
    if (isDemoAdvertiser) {
      setSeatData(accountListAll[0])
      return
    }

    let x = {};
    let y = {};
    platformData.forEach(item => {

      // console.log(accountData[item.value], "reduxDataForPlatform", item.value);
      let key = ''
      const lowerCasePlatform = item.value.toLowerCase();
      // const lowerCaseAds = platformConfig.ads.toLowerCase();
      // const lowerCaseViads = platformConfig.viads.toLowerCase();
      if (lowerCasePlatform == "google ads") {
        key = 'googleads'
        // return data.value.toLowerCase().includes(lowerCaseAds);
      } else {
        key = lowerCasePlatform;
      }
      // y = {
      //   ...y,
      //   [key]: 
      // }

      x = {
        ...x,
        [key]: formatOptions(accountData[key], item)
      };
    })
    const newArray = Object.keys(x).map((item) => ({ checked: true, platform: item }))
    setArrowDisable(newArray);
    setSeatData(prev => {
      // let y = {}
      // if (x && Object.keys(x).length > 0) {
      //   Object.keys(prev).forEach(item => {
      //     y = {
      //       ...y,
      //       ...prev[item],
      //       [item]: x[item] && x[item].length > 0 ? x[item] : []
      //     }
      //   })
      // console.log(x, "SEAT DATA");
      // }
      return x

    });
    setAllTrue();
  }

  const getPlatformImage = (platform) => {
    // console.log(platform, "dv360");
    switch (platform) {
      case 'Google Ads':
        return adwords;
      case 'Meta':
        return meta;
      case 'DV360' || 'dv360':
        return dv360;
      case 'tiktok':
        return tiktok;
      case 'ION':
        return ion;
      case 'ViAds':
        return ViImage;
      // Add more cases for other platforms as needed
      default:
        return adwords;
    }
  };

  const handleChange = (e, platform, index) => {
    const { name, value } = e.target;
    // SET PLATFORM ID INTO ALL THE CAMPAIGNS OF THAT INDEX
    // console.log("XXX", platform, seatData[platform][index], index, "HANDLECHANGE", seatData);

    // setDataValidate(prev => {
    //   const x = campaingData
    //   const y = prev;
    //   x.forEach(item => {
    //     if (item.platform == index) {
    //       y.push({
    //         ...item,
    //         accountId: value,
    //       });
    //     }
    //   })
    //   return y
    // });

    setSelectedAccountIds((prevAccountIds) => {
      setCampaignData(prev => {
        const x = [...prev]
        const y = x.map(item => {
          if (item.platform == index) {
            const mccAccountId = seatData[platform].find(item => item.value == value).mccAccountId
            item['accountId'] = value;
            item['bekiAccountId'] = tenantId
            item['mccAccountId'] = mccAccountId ? mccAccountId : ''
          }
          return item
        })
        return y
      })

      return {
        ...prevAccountIds,
        [platform]: value,
      }
    });
  };



  // const handleChange = (e, platform, index) => {
  //   const { name, value } = e.target;
  //   // SET PLATFORM ID INTO ALL THE CAMPAIGNS OF THAT INDEX

  //   // setDataValidate(prev => {
  //   //   const x = campaingData
  //   //   const y = prev;
  //   //   x.forEach(item => {
  //   //     if (item.platform == index) {
  //   //       y.push({
  //   //         ...item,
  //   //         accountId: value,
  //   //       });
  //   //     }
  //   //   })
  //   //   return y
  //   // });
  //   setSelectedAccountIds((prevAccountIds) => {
  //     setCampaignData(prev => {
  //       const x = [...prev]
  //       const y = x.map((item, i) => {
  //         //Item is an array here
  //         if (item.length > 0 && index == i) {
  //           const z = item.map(obj => {
  //             const mccAccountId = seatData[platform].find(item => item.value == value).mccAccountId
  //             return ({ ...obj, 'accountId': value, 'bekiAccountId': tenantId, mccAccountId: mccAccountId ? mccAccountId : '' })
  //           })
  //           return z;
  //         } else {
  //           return item
  //         }
  //       })
  //       return y;
  //     })
  //     // setCampaignData(prev => {
  //     //   const x = [...prev]
  //     //   const y = x[index].map(item => {
  //     //     if (item.platform == index) {
  //     //       item['accountId'] = value;
  //     //       item['bekiAccountId'] = tenantId
  //     //       item['mccAccountId'] = mccAccountId ? mccAccountId : ''
  //     //     }
  //     //     return item
  //     //   })
  //     //   return [...x, x[index]= y]
  //     // })

  //     return {
  //       ...prevAccountIds,
  //       [platform]: value,
  //     }
  //   });
  // };

  const handleTouch = (e, key1, key2, formFields = {}) => {
    const { name, value } = e.target;
    const { error } = handleFieldError(value, formFields[name]);
  };

  const handleHorizantalScroll = (e, element, speed, distance, step, index, from) => {
    e.preventDefault();
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      // Calculate maximum and minimum scrollable widths
      const maxScrollWidth = element.current.scrollWidth - element.current.clientWidth;
      const minScrollWidth = 0;

      // Check if the user can go back (scroll to the left)
      const canGoBack = element.current.scrollLeft > minScrollWidth;

      // Check if the user can go forward (scroll to the right)
      const canGoForward = element.current.scrollLeft < maxScrollWidth;

      element.current.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
      {/* { campaign: { showBackward: false, showForward: true }, strategy: { showBackward: false, showForward: true } } */ }
      // console.log(element.current.scrollWidth != element.current.clientWidth && element.current.scrollLeft == element.current.scrollWidth - element.current.clientWidth, "element.current", element.current.scrollWidth, '!==', element.current.clientWidth, '&&', element.current.scrollLeft, '===', element.current.scrollWidth - element.current.clientWidth);
      setArrowDisable(prev => {
        let x = [...prev];
        if (element.current.scrollWidth === element.current.clientWidth || element.current.scrollLeft === 0) {
          x[index][from]['showBackward'] = false;
          x[index][from]['showForward'] = true;
          return x;
        }
        if (element.current.scrollWidth - element.current.clientWidth === 0 && element.current.scrollLeft === 0) {
          let x = [...prev];
          x[index][from]['showBackward'] = false;
          x[index][from]['showForward'] = false;
          return x;
        }
        if (element.current.scrollWidth - element.current.clientWidth > element.current.scrollLeft && element.current.scrollLeft !== 0) {
          let x = [...prev];
          x[index][from]['showBackward'] = true;
          x[index][from]['showForward'] = true;
          return x;
        }
        if (element.current.scrollWidth != element.current.clientWidth && element.current.scrollLeft == element.current.scrollWidth - element.current.clientWidth) {
          let x = [...prev];
          x[index][from]['showBackward'] = true;
          x[index][from]['showForward'] = false;
          // console.log(x, "element.current");
          return x;
        }
        return x;
      });
    }, speed);
  };


  const handleCampaignSelect = (e, index, data) => {
    e.preventDefault()
    if (selectedCampaign[index].id !== data.id) {
      const x = campaigns[index].map((item, i) => {
        if (item.id == data.id) {
          if (item.strategies.length > 0) {
            item.strategies[0]['selected'] = true;

            if (item.strategyId == data.strategyId) {
              setSelectedStrategy(prevState => {
                // Create a copy of the state array
                const selectedCampaign = [...prevState];
                // Replace the array at the specified index with the new array
                selectedCampaign[index] = item.strategies[0];
                return selectedCampaign;
              });
            }

            setStrategies(prevState => {
              // Create a copy of the state array
              const selectedCampaign = [...prevState];
              // Replace the array at the specified index with the new array
              selectedCampaign[index] = item.strategies;
              return selectedCampaign;
            })
          }


          setStrategyTrue();
          elementStrategyRef.current[index].current.scrollLeft = 0
          setSelectedCampaign(prevState => {
            const selectedCampaign = [...prevState];
            selectedCampaign[index] = item;
            return selectedCampaign;
          });
        }

        return {
          ...item,
          selected: item.id == data.id,
        }

      })

      setCampaigns(prevState => {
        // Create a copy of the state array
        const campaigns = [...prevState];
        // Replace the array at the specified index with the new array
        campaigns[index] = x;
        return campaigns;
      });
    }
  }


  const handleStrategySelect = (index, data) => {
    const x = (selectedCampaign[index].strategies || []).map((item, i) => {
      if (item.id == data.id) {
        setSelectedStrategy(prevState => {
          // Create a copy of the state array
          const selectedCampaign = [...prevState];
          // Replace the array at the specified index with the new array
          selectedCampaign[index] = item;
          return selectedCampaign;
        });
      }
      return {
        ...item,
        selected: item.id == data.id,
      }
    })

    setStrategies(prevState => {
      // Create a copy of the state array
      const selectedCampaign = [...prevState];
      // Replace the array at the specified index with the new array
      selectedCampaign[index] = x;
      return selectedCampaign;
    })
    // setSelectedCampaign([{
    //   ...selectedCampaign[index],
    //   strategies: x,
    // }]);
  }


  const Slider = (key, data, on) => {
    // const handleContainerLoad = () => {
    //   const ref = on === 'campaign' ? elementCampaignRef.current[key] : elementStrategyRef.current[key]
    //   if (ref.current !== null) {
    //     const dynamicContentWidth = ref.current.getBoundingClientRect().width;
    //     const maxScrollWidth = ref.current.scrollWidth - ref.current.clientWidth;
    //     if (maxScrollWidth == 0 && dynamicContentWidth > maxScrollWidth) {
    //       if (!arrowDisable[key][on]['showBackward'] && arrowDisable[key][on]['showForward']) {
    //         setArrowDisable(prev => {
    //           let x = [...prev];
    //           x[key][on]['showBackward'] = false;
    //           x[key][on]['showForward'] = false;
    //           return x;
    //         })
    //       }
    //     }
    //   }
    // };

    // handleContainerLoad();
    return (
      <>
        <div style={{
          display: 'flex',
          overflow: 'hidden',
          width: '100%',
        }}
          id={key}
          ref={on === 'campaign' ? elementCampaignRef.current[key] : elementStrategyRef.current[key]}
        >

          {
            (data || []).map((item, i) => (
              <div
                key={i}
                style={{
                  width: 'min-content'
                }}>

                <div style={{
                  background: item.selected ? "#C4CCD8" : '',
                  border: on === 'campaign' ? item.suggestedName ? '1px solid red' : item.selected ? '' : '1px solid #707B8A' : item.selected ? '' : '1px solid #707B8A',
                  width: 'max-content',
                  height: '23px',
                  'border-radius': '100px',
                  margin: '0px 8px 0px 0px',
                  display: 'flex',
                  'flex-direction': 'row',
                  'flex-wrap': 'nowrap',
                  'justify-content': 'center',
                  'align-items': 'center',
                }}
                  onClick={on === 'campaign' ? e => handleCampaignSelect(e, key, item) : e => handleStrategySelect(key, item)}
                  key={i}
                >
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': "500",
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      color: item.selected ? '#394256' : '',
                      cursor: 'pointer',
                      padding: '5px',
                    }}
                    key={i}
                  >{item.name || item.strategyName}</span>
                </div>
              </div>
            ))
          }
        </div>
      </>
    )
  }

  const StrategySelected = (index) => {
    let processedData = [];
    let searchData = [];
    if (selectedStrategy && selectedStrategy[index] && selectedStrategy[index]['creative'] && selectedStrategy[index]['creative']['creativeDetails'] && selectedStrategy[index]['creative']['creativeDetails'].length > 0) {
      processedData = selectedStrategy[index]['creative']['creativeDetails'].filter(
        (data) => data.mediaList.length > 0
      );
    }
    if (selectedStrategy && selectedStrategy[index] && selectedStrategy[index]['creative'] && selectedStrategy[index]['creative']['creatives'] && selectedStrategy[index]['creative']['creatives'].length > 0) {
      searchData = selectedStrategy[index]['creative']['creatives'][0]
    }
    return (
      <>
        <div
          style={{
            // marginTop: '8px',
            margin: '8px 0px 16px 0px',
            width: '339px',
            height: 'auto',
            border: '1px solid #C4CCD8',
            'border-radius': '8px',
            backgroundColor: 'rgb(255, 255, 255)',
            display: 'flex',
            'flex-direction': 'column',
            'flex-wrap': 'nowrap',
            'justify-content': 'center',
            'align-items': 'center',
          }}
        >
          <div style={{
            margin: '12px 12px 12px 12px',
          }}>
            <div style={{
              width: '315px',
              height: selectedStrategy[index] && selectedStrategy.some(obj => obj.hasOwnProperty("convertedBudget")) ? '34px' : '',
            }}>
              {/* VALIDATE k baad dikha */}
              {selectedStrategy[index] && selectedStrategy[index].convertedBudget && <div
                style={{
                  display: 'flex',
                  'flex-direction': 'row',
                  'flex-wrap': 'nowrap',
                  'justify-content': 'space-between',
                  'align-items': 'center',
                  width: '315px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    'flex-direction': 'column',
                  }}
                >
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': '400',
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      margin: '0px 0px 4px 0px',
                    }}
                  >{`Budget (${selectedStrategy[index].convertedCurrency ? selectedStrategy[index].convertedCurrency : ''})`}</span>
                  <span style={{
                    'font-family': 'Poppins',
                    'font-size': '11px',
                    'font-weight': '500',
                    'line-height': '13px',
                    'letter-spacing': '0em',
                    'text-align': 'left',
                    color: '#040B1B',
                    margin: '4px 0px 0px 0px',
                  }}
                  >{selectedStrategy[index].convertedBudget}</span>
                </div>
                <div

                  style={{
                    display: 'flex',
                    'flex-direction': 'column',
                  }}
                >
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': '400',
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      margin: '0px 0px 4px 0px',

                    }}
                  >Start Date</span>
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': '500',
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      color: '#040B1B',
                      margin: '4px 0px 0px 0px',
                    }}
                  >
                    {/* {selectedStrategy[index].startDate} */}
                    {moment(getDateFromUtcToSpecificZone({ date: selectedStrategy[index].startDate, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD')}
                  </span>
                </div>
                <div

                  style={{
                    display: 'flex',
                    'flex-direction': 'column',
                  }}
                >
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': '400',
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      margin: '0px 0px 4px 0px',
                    }}
                  >End Date</span>
                  <span
                    style={{
                      'font-family': 'Poppins',
                      'font-size': '11px',
                      'font-weight': '500',
                      'line-height': '13px',
                      'letter-spacing': '0em',
                      'text-align': 'left',
                      color: '#040B1B',
                      margin: '4px 0px 0px 0px',
                    }}
                  >
                    {/* {selectedStrategy[index].endDate} */}
                    {moment(getDateFromUtcToSpecificZone({ date: selectedStrategy[index].endDate, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD')}
                  </span>
                </div>
              </div>}
            </div>
            {/* CRAETIVE TILE LAGA YAHA */}
            <div style={{
              marginTop: '16px',
              display: 'flex',
              'flex-direction': 'row',
              'flex-wrap': 'wrap',
              'align-content': 'flex-start',
              'justify-content': 'flex-start',
              'align-items': 'center',
            }}>
              {
                selectedStrategy[index]['creative'] && selectedStrategy[index]['creative']['creativeDetails'] && selectedStrategy[index]['creative']['creativeDetails'].length > 0 ?

                  <>
                    {processedData.map((data, creativeIndex) => {
                      return (
                        <>
                          <div style={{
                            width: '127px',
                            height: 'min-content',
                            'border-radius': '7.57px',
                            border: '0.68px solid #C4CCD8',
                            margin: '0px 8.48px 10px 0px',
                            display: 'flex',
                            'flex-direction': 'column',
                            'flex-wrap': 'nowrap',
                            'align-content': 'center',
                            'justify-content': 'flex-start',
                            'align-items': 'center',
                            position: 'relative'
                          }}>
                            <div style={{
                              width: '127px',
                              height: '71.87px',
                            }}>
                              {data.isSynced === 0 ? creativeConfig && creativeConfig[index] && creativeConfig[index]['list'] && creativeConfig[index]['list'].map(item => {
                                if (item.id == data.crType) {
                                  if (item.name == 'Display') {
                                    return <LazyLoadImage
                                      alt={""}
                                      src={data.mediaList[0].url}
                                      effect="blur"
                                      style={{
                                        width: '123.46px',
                                        height: '71.87px',
                                        objectFit: "cover",
                                        overflow: 'hidden',
                                        'border-radius': '6.93px 6.93px 0px 0px',
                                      }}
                                    />
                                  } else if (item.name == 'Video') {
                                    return <video
                                      width="100%"
                                      height="71.87"
                                      style={{
                                        objectFit: "cover",
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        display: "block",
                                      }}
                                    >
                                      <source src={data.mediaList[0].url} type="video/mp4" />
                                    </video>
                                  } else if (item.name == 'Search') {
                                    return <div>SEARCH</div>
                                  }
                                }
                              }) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: '71.87px',
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    backgroundColor: "#acacad",
                                  }}
                                >
                                  <p
                                    style={{
                                      textWrap: "wrap",
                                      fontSize: 7,
                                      padding: "12px 0px 0px 5px",
                                      color: "white",
                                    }}
                                    className="creativeImageHeadingText"
                                  >
                                    The creative preview is currently unavailable. To view it, please log in
                                    to the respective platform or consider adding a new creative from {platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name']}.
                                  </p>
                                </div>
                              )
                              }
                            </div>

                            <div style={{
                              width: '117.89px',
                              height: 'auto',
                              margin: '7.57px 0px ',
                              display: 'flex',
                              'flex-direction': 'column',
                              'flex-wrap': 'nowrap',
                              'align-content': 'flex-start',
                              'align-items': 'flex-start',
                              'justify-content': 'flex-start',
                            }}>
                              <span style={{
                                width: 'inherit',
                                height: '11px',
                                'font-family': 'Poppins',
                                'font-size': '8.2px',
                                'font-weight': '600',
                                'line-height': '11px',
                                'letter-spacing': '0em',
                                'text-align': 'left',
                                color: '#040B1B',
                              }}>{data.title.length > 24 ? `${data.title.substring(0, 23)}...` : data.title}</span>
                              <span style={{
                                width: 'inherit',
                                height: '11px',
                                'font-family': 'Poppins',
                                'font-size': '6.93px',
                                'font-weight': '600',
                                'line-height': '8.32px',
                                'letter-spacing': '0em',
                                'text-align': 'left',
                                color: '#707B8A',
                              }}>{data.description ? data.description.length > 23 ? `${data.description.substring(0, 20)}...` : data.description : ''}</span>
                              <div className="" style={{
                                position: 'absolute',
                                top: '0px',
                                left: '8px'
                              }}>
                                {data.isSynced !== 1 && <div>
                                  <img src={
                                    ImageIcon
                                  }
                                    alt="image" />
                                  <span className="ml-1" style={{
                                    'font-size': '10px',
                                    'font-weight': '500',
                                    color: '#ffffff',
                                    'font-family': "Poppins",
                                  }}>
                                    {" "}
                                    1/{data.mediaList.length}
                                  </span>
                                </div>}
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    })
                    }
                  </>
                  :
                  selectedStrategy && selectedStrategy[index] && selectedStrategy[index]['creative'] && selectedStrategy[index]['creative']['creatives'] && selectedStrategy[index]['creative']['creatives'].length > 0 ?
                    <div style={{
                      width: '165px',
                      minHeight: '109px',
                      height: 'auto',
                      'border-radius': '8.2px',
                      border: '0.74px solid #C4CCD8',
                      backgroundColor: '#F7F8FC',
                      display: 'flex',
                      'flex-direction': 'column',
                      'flex-wrap': 'nowrap',
                      'align-content': 'center',
                      'justify-content': 'center',
                      'align-items': 'center',
                      'gap': '6px'
                    }}>
                      {searchData && searchData['heading'] && searchData['heading'].length > 0 &&
                        <div style={{
                          'display': 'flex',
                          'flex-direction': 'column',
                          'align-content': 'center',
                          'flex-wrap': 'nowrap',
                          'align-items': 'center',
                          gap: '6px',
                        }}>
                          {
                            (searchData['heading'] || []).map((heading, index) =>
                            (<span style={{
                              height: index == 0 ? '14px' : '11px',
                              'font-family': 'Poppins',
                              'font-size': index == 0 ? '10px' : '9px',
                              'font-weight': index == 0 ? '600' : '400',
                              'line-height': index == 0 ? '14px' : '11px',
                              'letter-spacing': '0em',
                              'text-align': 'left',
                            }}>{heading.length > 24 ? `${heading.substring(0, 24)}...` : heading}</span>
                            ))

                          }
                          {
                            (searchData['description'] || []).map((description, index) =>
                            (<span style={{
                              height: index == 0 ? '14px' : '11px',
                              'font-family': 'Poppins',
                              'font-size': index == 0 ? '10px' : '9px',
                              'font-weight': index == 0 ? '600' : '400',
                              'line-height': index == 0 ? '14px' : '11px',
                              'letter-spacing': '0em',
                              'text-align': 'left',
                            }}>{description.length > 24 ? `${description.substring(0, 24)}...` : description}</span>
                            ))
                          }
                        </div>
                      }
                    </div>
                    :
                    <div style={{
                      width: '165px',
                      height: '109px',
                      'border-radius': '8.2px',
                      border: '0.74px solid #C4CCD8',
                      backgroundColor: '#F7F8FC'
                    }}>
                      No Creatives Mapped
                    </div>
              }
            </div>
          </div>
        </div >
      </>
    )
  }

  const handleCampaignNameSelect = (data, name) => {
    setCampaignData(prev => {
      const x = [...prev]
      let index = x.findIndex(item => item.name == data.name)
      if (index !== -1) {
        delete data.suggestedName;
        x[index] = { ...data, name }
      }
      return x
    })
  }

  const handleChangeCampaignName = (e, index, data) => {
    const { name, value } = e.target;
    setCampaignData(prev => {
      const x = [...prev]
      let index = x.findIndex(item => item.name == data.name)
      if (index !== -1) {
        x[index] = { ...data, name: value }
      }
      return x
    })
  }

  const CampaignSelected = (index, data) => (
    <>
      {selectedCampaign && selectedCampaign[index] && <div
        style={{
          margin: '8px 0px 16px 0px',
          width: '339px',
          height: 'auto',
          border: '1px solid #C4CCD8',
          'border-radius': '8px',
          backgroundColor: 'rgb(255, 255, 255)',
          display: 'flex',
          'flex-direction': 'column',
          'flex-wrap': 'nowrap',
          'justify-content': 'center',
          'align-items': 'center',
        }}
      >
        <div style={{
          margin: '0px 12px 12px 12px'
        }}>
          <div style={{
            width: '315px',
            height: '101px',
          }}>
            <Input
              onChange={e => handleChangeCampaignName(e, index, selectedCampaign[index])}
              onBlur={handleTouch}
              value={selectedCampaign[index].name}
              setting={formFields[formFields.name.key]}
              error={errors[formFields.name.key]}
              submited={submited}
              disabled={selectedCampaign[index].suggestedName ? false : true}
              touched={touched[formFields.name.key]}
            />
          </div>
          {/* DISPLAYING NAME SUGGESTIONS HERE */}
          {selectedCampaign[index].suggestedName &&
            <div style={{
              display: 'flex',
              'flex-direction': 'row',
              'flex-wrap': 'nowrap',
              'justify-content': 'space-between',
              'align-items': 'center',
              'align-content': 'center',
              'margin': '0px 0px 20px 0px',
            }}>
              <span style={{
                'font-family': 'Poppins',
                'font-size': '11px',
                'font-weight': '400',
                'line-height': '13px',
                'letter-spacing': '0em',
                'text-align': 'left',
              }}>{selectedCampaign[index].suggestedName}</span>
              <div style={{
                display: 'flex',
                gap: '10px',
              }}>
                <div>
                  <svg onClick={e => handleCampaignNameSelect(selectedCampaign[index], selectedCampaign[index].suggestedName)} style={{ cursor: 'pointer' }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33333 9.33333L6 11.3333L12 4" stroke="#288E49" stroke-width="1.5" />
                  </svg>
                </div>
                {/* <div>
                  <svg style={{cursor: 'pointer'}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4L4 12" stroke="#FF2700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4 4L12 12" stroke="#FF2700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </div> */}
              </div>
            </div>
          }
          {/* DISPLAY ON VALIDATE */}
          {selectedCampaign[index].hasOwnProperty('convertedBudget') && <div
            style={{
              display: 'flex',
              'flex-direction': 'row',
              'flex-wrap': 'nowrap',
              'justify-content': 'space-between',
              'align-items': 'center',
              width: '315px',
            }}
          >
            <div
              style={{
                display: 'flex',
                'flex-direction': 'column',
              }}
            >
              <span
                style={{
                  'font-family': 'Poppins',
                  'font-size': '11px',
                  'font-weight': '400',
                  'line-height': '13px',
                  'letter-spacing': '0em',
                  'text-align': 'left',
                  margin: '0px 0px 4px 0px',
                }}
              >{`Budget (${selectedCampaign[index].convertedCurrency})`}</span>
              <span style={{
                'font-family': 'Poppins',
                'font-size': '11px',
                'font-weight': '500',
                'line-height': '13px',
                'letter-spacing': '0em',
                'text-align': 'left',
                color: '#040B1B',
                margin: '4px 0px 0px 0px',
              }}
              >{selectedCampaign[index].convertedBudget}</span>
            </div>
            <div

              style={{
                display: 'flex',
                'flex-direction': 'column',
              }}
            >
              <span
                style={{
                  'font-family': 'Poppins',
                  'font-size': '11px',
                  'font-weight': '400',
                  'line-height': '13px',
                  'letter-spacing': '0em',
                  'text-align': 'left',
                  margin: '0px 0px 4px 0px',

                }}
              >Start Date</span>
              <span
                style={{
                  'font-family': 'Poppins',
                  'font-size': '11px',
                  'font-weight': '500',
                  'line-height': '13px',
                  'letter-spacing': '0em',
                  'text-align': 'left',
                  color: '#040B1B',
                  margin: '4px 0px 0px 0px',
                }}
              >{moment(getDateFromUtcToSpecificZone({ date: selectedCampaign[index].startDate, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD')}</span>
            </div>
            <div

              style={{
                display: 'flex',
                'flex-direction': 'column',
              }}
            >
              <span
                style={{
                  'font-family': 'Poppins',
                  'font-size': '11px',
                  'font-weight': '400',
                  'line-height': '13px',
                  'letter-spacing': '0em',
                  'text-align': 'left',
                  margin: '0px 0px 4px 0px',
                }}
              >End Date</span>
              <span
                style={{
                  'font-family': 'Poppins',
                  'font-size': '11px',
                  'font-weight': '500',
                  'line-height': '13px',
                  'letter-spacing': '0em',
                  'text-align': 'left',
                  color: '#040B1B',
                  margin: '4px 0px 0px 0px',
                }}
              >{moment(getDateFromUtcToSpecificZone({ date: selectedCampaign[index].endDate, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD')}</span>
            </div>
          </div>}
        </div>
      </div>}
    </>
  )

  return (
    // RENDER
    <>

      {seatData && Object.keys(seatData) && Object.keys(seatData).length > 0 &&
        <div className={`d-flex ${props.isViewCampaign ? 'pe-none' : 'pe-auto'}`} style={{ 'overflow-x': 'scroll' }}>
          {(Object.keys(seatData) || []).map((item, index) => {
            return (
              <>
                {
                  campaigns && campaigns[index] && campaigns[index].length > 0 &&
                  <div style={{
                    'width': '380px',
                    'height': 'max-content',
                    'padding': '16px 20px 16px 20px',
                    'border-radius': '12px',
                    'border': '1px solid #C4CCD8',
                    'gap': '16px',
                    'margin': '0px 12px',
                    'backgroundColor': '#F7F8FC'
                  }}>
                    <div style={{
                      'width': '339px',
                      'height': '36px',
                      'display': 'flex',
                      'flex-direction': 'row',
                      'flex-wrap': "nowrap",
                      'align-content': 'center',
                      'align-items': "center",
                      'margin-bottom': '16px',
                      'justify-content': 'space-between',
                    }}>
                      <div style={{
                        'display': 'flex',
                        'flex-direction': 'row',
                        'flex-wrap': 'nowrap',
                        'justify-content': 'flex-start',
                        'align-items': 'center',
                      }}>
                        <img style={{
                          height: 36,
                          width: 36,
                          objectFit: "contain",
                          margin: '0px 12px 0px 0px',
                        }}
                          // src={getPlatformImage(item)
                          src={seatData[item] && seatData[item].length > 0 && seatData[item][0]['platformImage']}
                        />
                        {seatData[item] && seatData[item].length > 0 && seatData[item][0]['platformName']}
                      </div>
                      <input
                        style={{ display: 'none' }}
                        type="checkbox"
                        onChange={() => handleCheckboxChange(seatData[item][0]['platform'])}
                        checked={seatData && seatData[item] && seatData[item].length > 0 && seatData[item][0]['platform'] && campaigns[index].length > 0 ? selectedPlatforms.includes(seatData[item][0]['platform']) : false}
                        disabled={campaigns[index].length == 0}
                      />
                    </div>
                    <div>
                      {/* <SelectNew
                      onChange={(e) => handleChange(e, item, index)}
                      onBlur={handleTouch}
                      value={campaigns[index].some(obj => obj.status != '2' && obj.status != '3') ? campaigns[index].find(obj => obj.hasOwnProperty('accountId')).accountId : selectedAccountIds[item]} // Make sure to handle the case where the value is undefined or null
                      // value={selectedAccountIds[item]} // Make sure to handle the case where the value is undefined or null
                      setting={formFields[formFields.accountSeat.key]}
                      error={errors[formFields.accountSeat.key]}
                      submited={submited}
                      touched={touched[formFields.accountSeat.key]}
                      options={seatData[item].filter(obj => obj.hasOwnProperty('label') && obj.label != null)}
                      disabled={campaigns[index].some(obj => obj.status != '2' && obj.status != '3')}
                    /> */}
                      <SelectNew
                        onChange={(e) => handleChange(e, item, index)}
                        onBlur={handleTouch}
                        value={
                          campaigns[index].some(obj => obj.platformName === 'meta' && (obj.status !== '2' && obj.status !== '3'))
                            ? isDemoAdvertiser ? '735759678205531' : campaigns[index].find(obj => obj.platformName === 'meta').accountId
                            : campaigns[index].some(obj => obj.status != '2' && obj.status != '3') ?
                              campaigns[index].find(obj => obj.hasOwnProperty('accountId')).accountId :
                              selectedAccountIds[item]
                        }
                        // value={
                        //   campaigns[index].some(obj => obj.status != '2' && obj.status != '3') ? 
                        //   campaigns[index].find(obj => obj.hasOwnProperty('accountId')).accountId : 
                        //   selectedAccountIds[item]
                        // } 
                        setting={formFields[formFields.accountSeat.key]}
                        error={errors[formFields.accountSeat.key]}
                        submited={submited}
                        touched={touched[formFields.accountSeat.key]}
                        options={seatData[item].filter(obj => obj.hasOwnProperty('label') && obj.label != null)}
                        disabled={campaigns[index].some(obj => (obj.status != '2' && obj.status != '3') || obj.platformName === 'meta')}
                      />
                    </div>
                    {<div>
                      <div style={{
                        width: "338px",
                        'display': 'flex',
                        'flex-direction': 'row',
                        'flex-wrap': "nowrap",
                        'align-content': 'center',
                        'justify-content': 'space-between',
                        'align-items': 'center',
                      }}
                      >
                        {arrowDisable[index]['campaign']['showBackward'] && <svg
                          style={{
                            cursor: 'pointer',
                            //   display: arrowDisable[index]['campaign'] && arrowDisable[index]['campaign']['showBackward'] == false ? "none" : '',
                          }}
                          onClick={(e) => {
                            handleHorizantalScroll(e, elementCampaignRef.current[index], 10, 275, -100, index, 'campaign');
                          }}
                          width="24" height="24" viewBox="0 0 24 24"><path fill="black" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6z" /></svg>}
                        <div style={{ width: '100%', 'overflow': 'hidden', }} >
                          <div className='d-flex' style={{ width: '100%', 'overflow-x': 'auto' }}>
                            {Slider(index, campaigns[index], 'campaign')}
                          </div>
                        </div>
                        {arrowDisable[index]['campaign']['showForward'] && <svg
                          style={{
                            cursor: 'pointer',
                            // display: arrowDisable[index]['campaign'] && arrowDisable[index]['campaign']['showForward'] ? "" : 'none',
                          }}
                          onClick={(e) => {
                            handleHorizantalScroll(e, elementCampaignRef.current[index], 10, 275, 100, index, 'campaign');
                          }}
                          width="24" height="24" viewBox="0 0 24 24"><path fill="#040B1B" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z"
                          /></svg>}
                      </div>
                      <div>
                        {/* CAMPAIGN SELECTED TO BE DISPLAYED */}
                        {CampaignSelected(index, item)}
                      </div>
                      <div style={{
                        width: "338px",
                        'display': 'flex',
                        'flex-direction': 'row',
                        'flex-wrap': "nowrap",
                        'align-content': 'center',
                        'justify-content': 'space-between',
                        'align-items': 'center',
                      }}
                      >
                        {arrowDisable[index]['strategy']['showBackward'] && <svg
                          style={{
                            cursor: 'pointer',
                            // display: arrowDisable[index]['strategy'] && arrowDisable[index]['strategy']['showBackward'] ? "" : 'none',
                          }}
                          onClick={(e) => {
                            handleHorizantalScroll(e, elementStrategyRef.current[index], 10, 275, -100, index, 'strategy');
                          }}
                          width="24" height="24" viewBox="0 0 24 24"><path fill="black" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6z" /></svg>}
                        <div style={{ width: '100%', 'overflow': 'hidden', }} >
                          <div className='d-flex' style={{ width: '100%', 'overflow-x': 'auto' }}>
                            {Slider(index, strategyies[index], 'strategy')}
                          </div>
                        </div>
                        {arrowDisable[index]['strategy']['showForward'] && <svg
                          style={{
                            cursor: 'pointer',
                            // display: arrowDisable[index]['strategy'] && arrowDisable[index]['strategy']['showForward'] ? "" : 'none',
                          }}
                          onClick={(e) => {
                            // e, element, speed, distance, step, index, from
                            handleHorizantalScroll(e, elementStrategyRef.current[index], 10, 275, 100, index, 'strategy');
                          }}
                          width="24" height="24" viewBox="0 0 24 24"><path fill="#040B1B" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z"
                          /></svg>}
                      </div>
                      <div>
                        {/* CAMPAIGN SELECTED TO BE DISPLAYED */}
                        {StrategySelected(index, item)}
                      </div>
                    </div>}
                  </div>}
              </>
            )
          })}
        </div>}
    </>
  )

};

export default withRouter(PreviewPublish);